import(/* webpackMode: "eager" */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/app/pages/science/page.tsx");
